///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.front_store = abcsetup.front_store || {};
abcsetup.front_store.show = abcsetup.front_store.show || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.front_store.show = {
    init: function() {
        abcsetup.setTitle('View Consumer Item');

        // Set the global item var
        abcsetup.item = JSON.parse($('form.front-store-item #item_object').html());
        abcsetup.form_manager.form = $('form.front-store-item');
        abcsetup.form_manager.setAndCreate(true);

        // Init the attachments
        this._initAttachments();

        if (abcsetup.item.type == 'display') {
            // Init the display items
            this._initDisplayItems();
        }
    },

    /**
     * _jquery.fieldLib hase been init - this is the callback
     */
    fieldsInit: function() {
        // Note: all front store form related JS is handled in the global /forms/_front_store_item.js form namespace
        abcsetup.front_store.form.init(true);
    },

    /**
     *
     */
    _initAttachments: function() {
        $('#attachments .uploader-container').empty();
    },

    /**
     * Init the display items
     */
    _initDisplayItems: function() {
        if (abcsetup.item.front_store_display_item && abcsetup.item.front_store_display_item.length) {
            $(abcsetup.item.front_store_display_item).each(function() {
                var wac_total = this.a_b_c_item.wac * this.qty;
                var html = '';
                html = '<tr class="new_item">';
                html = html + '<input type="hidden" id="item_id_'+this.abc_item+'" name="display_items['+this.abc_item+'][abc_item]" class="item_id" value="'+this.abc_item+'">';
                html = html + '<td></td>';
                html = html + '<td>' + this.a_b_c_item.sap_num + '</td>';
                html = html + '<td>' + this.a_b_c_item.upc11 + '</td>';
                html = html + '<td>' + this.abc_item + '</td>';
                html = html + '<td>' + this.a_b_c_item.mfr_prod_code + '</td>';
                html = html + '<td>' + this.a_b_c_item.category_name + '</td>';
                html = html + '<td>' + this.a_b_c_item.mat_descr + '</td>';
                html = html + '<td>' + this.qty + '</td>';
                html = html + '<td class="wac_per_item currency">' + this.a_b_c_item.wac + '</td>';
                html = html + '<td class="wac_total currency">' + wac_total.toFixed(2) + '</td>';
                html = html + '<td class="attachment"></td>';
                html = html + '</tr>';

                // Append the new row
                $('#new_display_items_table').append(html);
            });
        }
    },
}
